const getReservaForm = (state) => {
    return state.reservaForm
}

// const getAtrativos = (state) =>{
//     return state.atrativos
// }

const getPlacePublicData = (state) => {
    return state.place_public_data
}

const getTermsConditions = (state) => {
    return state.terms_conditions
}

const getDialCodesArray = (state) => {
    return state.dialCodesArray
}

const getCountriesArray = (state) => {
    return state.countriesArray
}

const getStatesArray = (state) => {
    return state.statesArray
}

const getCitiesArray = (state) => {
    return state.citiesArray
}

const getCallbackUrlMP = (state) => {
    return state.callbackUrlMP
}

const getExpressBookingResponse = (state) => {
    return state.expressBookingResponse
}

const getWsStatusPaymentMP = (state) => {
    return state.wsStatusPaymentMP
}

export default {
    getReservaForm,
    // getAtrativos,
    getPlacePublicData,
    getTermsConditions,
    // getTotalCost,
    getDialCodesArray,
    getCountriesArray,
    getStatesArray,
    getCitiesArray,
    getCallbackUrlMP,
    getExpressBookingResponse,
    getWsStatusPaymentMP,
}
